import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=79f218ce&"
import script from "./TabbedView.vue?vue&type=script&lang=js&"
export * from "./TabbedView.vue?vue&type=script&lang=js&"
import style0 from "./TabbedView.vue?vue&type=style&index=0&id=79f218ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports